export default __webpack_public_path__ + "static/media/39.ca526520.jpg";